import * as types from './mutation-types';
import { SEARCH_PARAMS, POPUP_DATA, PAGING_INFO } from './state';

export default {
	[types.STATE_INIT]: state => {
		state.searchParams = SEARCH_PARAMS();
		state.pagingInfo = PAGING_INFO();

		state.isMmcAdmin = false;
		state.isisMmcGuest = false;

		state.eqipDtlCdList = []; //장비상세 selectBox
		state.eqipKndCdList = []; //장비종류 selectBox
		state.calStCdList = []; //교정상태 selectBox
		state.runStCdList = []; //가동상태 selectBox
		state.calWayCdList = []; //교정방식 selectBox
		state.calCyclCdList = []; //교정주기 selectBox
		state.calRsltCdList = []; //교정결과 selectBox
		state.runStCdList = []; //가동상태 selectBox
		state.ynCdList = []; //보고서유무 selectBox
		state.sndStCdList = []; //메일 발송상태 selectBox
		state.calInstCdList = []; //교정업체 selectBox
		state.utmCdList = []; // 측정 단위 selectBox

		state.resultList = [];
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	}
};
